export default __webpack_public_path__ + "static/media/trainer-large.18b1ae7e.webp";